import React from 'react';
import { AppContext } from 'context/AppContext';
import { isNullOrUndefined } from 'utils/validation';

const useApp = () => {
    const context = React.useContext(AppContext);

    if (isNullOrUndefined(context)) {
        throw new Error('AppContext was used outside of its provider');
    }

    return context;
};

export default useApp;
